import { CoopCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { OrderTextWithCatalogComponent } from '../../../commons/kymw02/text-input/order-text-with-catalog/order-text-with-catalog.component';
import { MediumTypeComboBoxComponent } from './../../../commons/kymw02/combo-box/medium-type-combo-box/medium-type-combo-box.component';
import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2000Model } from './kymw2000.model';
import { KYMW2000InputModel } from './vo/kymw2000-input.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { OrderNumQuotaCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/order-num-quota-code-combo-box/order-num-quota-code-combo-box.component';
import { WjTabPanel } from '@grapecity/wijmo.angular2.nav';
import { GetCycleMediumListService } from './api-services/get-cycle-medium-list.service'
import { GetCycleTempSelectedSummaryService } from './api-services/get-cycle-temp-selected-summary.service'
import { GetCycleTempSelectedSummaryByBuyerService } from './api-services/get-cycle-temp-selected-summary-by-buyer.service'
import { GetCycleOrderNumQuotaSelectedSummaryService } from './api-services/get-cycle-order-num-quota-selected-summary.service'
import { OutputCycleOrderNumQuotaSelectedSummaryService } from './api-services/output-cycle-order-num-quota-selected-summary.service'
import { GetPlanTempSelectedSummaryService } from './api-services/get-plan-temp-selected-summary.service'
import { GetPlanTempSelectedSummaryByBuyerService } from './api-services/get-plan-temp-selected-summary-by-buyer.service'
import { GetPlanOrderNumQuotaSelectedSummaryService } from './api-services/get-plan-order-num-quota-selected-summary.service'
import { OutputPlanOrderNumQuotaSelectedSummaryService } from './api-services/output-plan-order-num-quota-selected-summary.service'
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { GetMediumListService } from '../../../commons/kymw02/api-services/get-medium-list.service';

interface Validation {
  validate: () => boolean;
  code: string,
  message: string[];
}

/**
 * 選定済商品数一覧を管理するクラス
 *
 * @export KYMW2000Component
 * @class KYMW2000Component
 */
@Component({
  selector: 'app-kymw2000',
  templateUrl: './kymw2000.component.html',
  styleUrls: ['./kymw2000.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2000Component extends PlessViewHelperSub implements OnInit {

  model: KYMW2000Model = new KYMW2000Model();
  previous_mediumType = null;
  isInitialized = true;
  isInitTab = true;
  tabSelectedIndex = 0;

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: MediumTypeComboBoxComponent;
  @ViewChild('cmb_CoopCode', { static: true }) cmb_CoopCode: CoopCodeComboBoxComponent;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderTextWithCatalogComponent;
  @ViewChild('cmb_OrderNumQuota', { static: true }) cmb_OrderNumQuota: OrderNumQuotaCodeComboBoxComponent;
  @ViewChild('tab_Panel', { static: true }) tab_Panel: WjTabPanel;

  /**
   *Creates an instance of KYMW2000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2000Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getMediumListService: GetMediumListService,
    private getCycleMediumListService: GetCycleMediumListService,
    private getCycleTempSelectedSummaryService: GetCycleTempSelectedSummaryService,
    private getCycleTempSelectedSummaryByBuyerService: GetCycleTempSelectedSummaryByBuyerService,
    private getCycleOrderNumQuotaSelectedSummaryService: GetCycleOrderNumQuotaSelectedSummaryService,
    private outputCycleOrderNumQuotaSelectedSummaryService: OutputCycleOrderNumQuotaSelectedSummaryService,
    private getPlanTempSelectedSummaryService: GetPlanTempSelectedSummaryService,
    private getPlanTempSelectedSummaryByBuyerService: GetPlanTempSelectedSummaryByBuyerService,
    private getPlanOrderNumQuotaSelectedSummaryService: GetPlanOrderNumQuotaSelectedSummaryService,
    private outputPlanOrderNumQuotaSelectedSummaryService: OutputPlanOrderNumQuotaSelectedSummaryService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2000Component
   */
  ngOnInit() {
    this.componentName = 'KYMW2000';
    this.model.funcID = this.model.origineSource.funcID;
    this.model.mediumType = this.model.origineSource.mediumType ?? '';
    this.model.orderCode = this.model.origineSource.orderCode ?? '';

    if (this.model.funcID === 'KYMW1200') { // サイクル設定画面の場合
      this.getCycleMediumListService.execute(this.model, () => {
        this.model.updateMediumList();
        this.changeDisabled();
      });
    } else if (this.model.funcID === 'KYMW1300') { // 商品企画マスタ画面の場合
      this.tabSelectedIndex = 2; // 注文コード割当（部門別）タブ
      this.getMediumListService.execute(null, this.model, 'mediumList', () => {
        this.model.updateMediumList();
        this.changeDisabled();
      });
    } else { // 上記以外の場合
      this.getMediumListService.execute(null, this.model, 'mediumList', () => {
        this.model.updateMediumList();
        this.changeDisabled();
      });
    }
  }

  // 媒体セレクトボックス変更時
  onChangeMediumType(type: string) {
    if (type === this.previous_mediumType) return;

    this.previous_mediumType = type;
    this.clearList();
    this.getOrderNumQuotaList(type);
    this.changeDisabled();
  }

  // outputで返ってきたcatalogIdを設定
  onChangeCatalogId(event: string){
    this.model.catalogId = event;
  }

  // outputで返ってきたorderCodeを設定
  onChangeOrderCode(event: string){
    // 初回のみスキップ（初期化タイミングで受注コード→企画回ではなく企画回→受注コードで動く時があり、設定されたorderCodeが空文字で上書きされることがあったため）
    if (this.isInitialized) {
      this.isInitialized = false;
      return;
    }
    this.model.orderCode = event;
  }

  // 受注コード・企画回変更時
  onChangeText(){
    this.clearList();
    this.getOrderNumQuotaList(this.model.mediumType);
  }

  // タブ変更時
  onChangedTab(){
    // 初回スキップ
    if (this.isInitTab) {
      this.isInitTab = false;
      return;
    }
    if (!this.handleValidationErrors()) {
      return;
    }
    this.handleTabAction(this.tab_Panel.selectedIndex);
  }

  // 表示ボタンクリック時
  onClickDisplayButton(){
    if (!this.handleValidationErrors()) {
      return;
    }
    this.handleTabAction(this.tab_Panel.selectedIndex);
  }

  // 生協コード・受注コード割当コード変更時
  onChangeCode(){
    if (!this.handleValidationErrors()) {
      return;
    }
    this.handleTabAction(this.tab_Panel.selectedIndex);
  }

  // チェックボックス変更時
  onChangeCheckBox(){
    // 「注文コード割当（部門別）」タブの選定済商品数一覧内容をクリア
    this.model.orderDept = [];
    this.model.multiPublishFlg = PlessViewUtilsSub.booleanTOString(this.model.multiPublishItemCnt);
    this.cmb_OrderNumQuota.multiPublishFlg = this.model.multiPublishFlg
    
    // 「注文コード割当（部門別）」タブの注文コード割当の表示内容を設定
    this.getOrderNumQuotaList(this.model.mediumType);
  }

  // 注文コード割当コードコンボロード完了通知
  public orderNumQuotaLoadCompleted(code: string): void {
    this.model.orderNumQuota = code;
  }

  onClickOutputOrderNumQuota() {
    if (!this.handleValidationErrors()) {
      return;
    }
    this.handleReportExport();
  }
  
  // 遷移元と選択中のタブに応じた処理を実行
  handleTabAction(index: number) {
    if (this.model.funcID === "KYMW1200") {
      switch (index) {
        case 0: this.getCycleSummaryList(); break;
        case 1: this.getCycleByBuyerList(); break;
        case 2: this.getCycleOrderDeptList(); break;
      }
    } else {
      switch (index) {
        case 0: this.getPlanSummaryList(); break;
        case 1: this.getPlanByBuyerList(); break;
        case 2: this.getPlanOrderDeptList(); break;
      }
    }
  }

  // 出力処理
  handleReportExport(){
    if (this.model.funcID === "KYMW1200") {
      this.outputCycleOrderNumQuotaSelectedSummaryService.execute(this.model, (data: any) => {
        this.setupFileDownload(data);
      });
    } else {
      this.outputPlanOrderNumQuotaSelectedSummaryService.execute(this.model, (data: any) => {
        this.setupFileDownload(data);
      });
    }
  }

  // 出力内容の設定
  setupFileDownload(data: any){
    const LIST_PREFIX = '注文コード割当確認一覧表_';
  
    // サーバファイル名の保存
    this.model.updateFileName(data);

    const filePrefix: string = LIST_PREFIX;

    // ローカルファイル名の作成
    const localfile: string = filePrefix + this.model.orderCode + '_'
      + this.model.mediumType + '_' + this.model.orderNumQuota + '_'
      + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.xls';
    
    // ダウンロードの確認画面を起動する
    this.fileDownloadConfirmService.show(data.FileName, localfile);
  }
  // 「注文コード割当（部門別）」タブの注文コード割当の表示内容を設定
  getOrderNumQuotaList(type: string) {
    // 注文コード割当の入力内容をクリア
    this.cmb_OrderNumQuota.clear();  
    this.model.orderNumQuota = '';
    // 媒体の選択が「ALL」以外かつ、受注コードが設定されている場合注文コード割当再取得
    if (this.model.selectedMediumName !== 'ALL' && this.txti_OrderCode.isValidOrderCode()) {
      this.cmb_OrderNumQuota.selectedIndex = 0;
      this.cmb_OrderNumQuota.orderCode = this.model.orderCode;
      this.cmb_OrderNumQuota.mediumType = type;
      this.cmb_OrderNumQuota.reload();
    // 上記条件を満たさない場合注文コード割当のセレクトボックスに空の選択肢を設定
    } else {
      this.cmb_OrderNumQuota.orderCode = '';
      this.cmb_OrderNumQuota.mediumType = '';
    }
  }

  // 各種タブの選定済商品数一覧内容をクリア
  clearList() {
    this.model.tempDept = [];
    this.model.tempBuyer = [];
    this.model.orderDept = [];
  }

  // 画面項目の活性状態を変更
  changeDisabled() {
    // disabledに設定しているので、活性したいときはfalseを設定
    // 媒体の選択がALLの時非活性、それ以外は活性化させる
    this.model.isOrderNumQuotaButton = this.model.selectedMediumName !== 'ALL' ? false : true;
    this.model.isMultiPublishItemCnt = this.model.selectedMediumName !== 'ALL' ? false : true;
  }

  // サイクル企画温度帯（部門別）選定済商品数一覧取得
  getCycleSummaryList() {
    this.getCycleTempSelectedSummaryService.execute(this.model, () => {
      this.model.updateTempDept();
    });
  }

  // サイクル企画温度帯（バイヤー別）選定済商品数一覧取得
  getCycleByBuyerList() {
    this.getCycleTempSelectedSummaryByBuyerService.execute(this.model, () => {
      this.model.updateTempBuyer();
    });
  }

  // サイクル企画温度帯（バイヤー別）選定済商品数一覧取得
  getCycleOrderDeptList() {
    this.getCycleOrderNumQuotaSelectedSummaryService.execute(this.model, () => {
      this.model.updateOrderDept();
    });
  }

  // サイクル企画温度帯（部門別）選定済商品数一覧取得
  getPlanSummaryList() {
    this.getPlanTempSelectedSummaryService.execute(this.model, () => {
      this.model.updateTempDept();
    });
  }
  
  // 企画温度帯（バイヤー別）選定済商品数一覧取得
  getPlanByBuyerList() {
    this.getPlanTempSelectedSummaryByBuyerService.execute(this.model, () => {
      this.model.updateTempBuyer();
    });
  }


  // サイクル企画温度帯（バイヤー別）選定済商品数一覧取得
  getPlanOrderDeptList() {
    this.getPlanOrderNumQuotaSelectedSummaryService.execute(this.model, () => {
      this.model.updateOrderDept();
    });
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   */
  setParams(data: KYMW2000InputModel) {
    this.model.origineSource = data;
  }

  private validations: Validation[] = [
    {
      validate: () => this.checkMediumType(),
      code: 'W0001',
      message: ['媒体']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.model.orderCode),
      code: 'W0001',
      message: ['受注コード']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.model.catalogId),
      code: 'W0001',
      message: ['企画回']
    },
    {
      validate: () => {
        if (this.tab_Panel.selectedIndex !== 2) return true;
        return !PlessViewUtilsSub.isEmpty(this.model.orderNumQuota);
      },
      code: 'W0001',
      message: ['注文コード割当コード']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.booleanTOString(this.model.multiPublishItemCnt)),
      code: 'W0001',
      message: ['Ｗ掲載商品数']
    },
    {
      validate: () => {
        if (this.model.mediumType === '') return true;
        if (this.model.mediumType !== '' && this.model.mediumType.length === 3) {
          return true;
        } else {
          return false;
        }
      },
      code: 'W0005',
      message: ['媒体', '3']
    },
    {
      validate: () => {
        if (this.model.orderCode.length === 7) {
          return true;
        } else {
          return false;
        }
      },
      code: 'W0005',
      message: ['受注コード', '7']
    },
    {
      validate: () => !PlessViewUtilsSub.isEmpty(this.model.catalogId),
      code: 'W0024',
      message: ['受注コード']
    },
    {
      validate: () => {
        if (this.tab_Panel.selectedIndex !== 2) return true;
        if (this.model.orderNumQuota.length === 3) {
          return true;
        } else {
          return false;
        }
      },
      code: 'W0005',
      message: ['注文コード割当コード', '3']
    },
  ];

  validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }
    return { code: error.code, message: error.message };
  }

  handleValidationErrors() {
    const error = this.validate();
    if (error) {
      this.dialogService.openAlertGetMessage(error.code, error.message);
      return false;
    }
    return true;
  }

  checkMediumType() {
    if (this.model.mediumType === null || this.model.mediumType === undefined) {
      return false;
    } else {
      return true;
    }
  }
}
